import { cn } from "@/lib/cn";
import { Button } from "./button";
import { useTranslations } from "next-intl";

type TMainSidebar = {
  className?: string;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isOpen: boolean;
  reset?: () => void;
} & React.PropsWithChildren;

const MainSidebar = ({
  className,
  children,
  setIsOpen,
  isOpen,
  reset,
}: TMainSidebar) => {
  const t = useTranslations();
  if (!children || typeof window === "undefined") return null;

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div
      style={{ background: "rgba(0, 0, 0, 0.6)" }}
      onClick={handleToggle}
      className="fixed inset-0 bg-opacity-50 z-50"
    >
      <div
        className={cn(
          "fixed right-0 top-0 h-svh  bg-light  dark:bg-input/70 dark:shadow-none dark:backdrop-blur-sm z-50  overflow-y-auto scrollbar-none w-full lg:w-[30%] xl:w-[23%] p-6 shadow-lg flex flex-col justify-between animate_from_right",
          className
        )}
        onClick={(e) => e.stopPropagation()}
      >
        {children}

        <div className="flex justify-end gap-4 mt-6 ">
          <Button
            onClick={handleToggle}
            className="!bg-transparent !text-primary dark:!text-white border border-white"
          >
            {t("Cancel")}
          </Button>

          <Button type="reset" onClick={() => reset?.()}>
            {t("Reset")}
          </Button>
          <Button type="submit">{t("Apply")}</Button>
        </div>
      </div>
    </div>
  );
};

export default MainSidebar;
